import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { Drawer, Button, Group } from "@mantine/core";
import "./Navbar.css";

const Navbar = () => {
  const [opened, setOpened] = useState(false);
  const [navClass, setNavClass] = useState(" navCover light-navCover");
  const [navLogo, setNavLogo] = useState("/assets/qevolt-logo.svg");
  const [ham, setHam] = useState("/assets/ham.svg");
  const [status, setStatus] = useState("#FDFBF9");

  const setDark = () => {
    setNavClass("navCover dark-navCover");
    setNavLogo("/assets/qevolt-light.svg");
    setHam("/assets/ham-light.svg");
    // setStatus("#121212");
  };
  const setLight = () => {
    setNavClass("navCover light-navCover");
    setNavLogo("/assets/qevolt-logo.svg");
    setHam("/assets/ham.svg");
    // setStatus("#FDFBF9");
  };

  document.getElementsByTagName("META")[2].content = status;

  useEffect(() => {
    const currentUrl = window.location.href;

    if (currentUrl.includes("about")) {
      setDark();
    } else {
      setLight();
    }
  });


  const checkRoute = ()=> {
    const currentPage = window.location.href;
    if(currentPage.includes("about")){
      setDark();
    }
    else{
      setLight();
    }
  }


  setInterval(checkRoute,10)



  const url = window.location.href;

  useEffect(() => {
    if (opened) {
      setStatus("#121212");
    } else if (!opened && !url.includes("about")) {
      setStatus("#FDFBF9");
    }
  }, [opened]);

  // const checkQevHome = () => {
  //   if (url.includes("about")) {
  //     setStatus("#121212");
  //   } else if (!url.includes("about")) {
  //     setStatus("#FDFBF9");
  //   }
  // };

  return (
    <div className={navClass}>
      <div className="navbar">
        <div className="navbar-left">
          <NavLink
            to="/"
            onClick={() => {
              setLight();
              setOpened(false);
              // checkQevHome();
              setStatus("FDFBF9");
            }}
          >
            <img src={navLogo} alt="" />
          </NavLink>
        </div>
        <div className="navbar-right ">
          <NavLink to="/about" onClick={setDark}>
            About
          </NavLink>
          <NavLink to="/pricing" onClick={setLight}>
            Pricing
          </NavLink>
          <NavLink to="/faqs" onClick={setLight}>
            FAQs
          </NavLink>
          <a href="https://medium.com/@qevoltlimited" target="_blank">
            Blog
          </a>
          <NavLink to="/contact" onClick={setLight}>
            Contact
          </NavLink>
          
          <a href="https://app.qevolt.com/account" target="_blank">
            Login
          </a>
          <a
            href="https://app.qevolt.com/account/signup"
            target="_blank"
            className="sign-anim"
          >
            Sign up
          </a>
        </div>
        <div className="mobile-nav">
          <Drawer
            opened={opened}
            onClose={() => setOpened(false)}
            padding="xl"
            size="100%"
            position="right"
            withOverlay={false}
            // overlayOpacity={1}
            // overlayBlur={7}
            transitionDuration={250}
            transitionTimingFunction=""
          >
            <div className="drawer-container">
              <div className="hamTop">
                <div className="hamLogo">
                  <NavLink to="/" onClick={() => setOpened(false)}>
                    <img src="/assets/white-qevolt.svg" alt="" />
                  </NavLink>
                </div>
                <div className="closeMenu " onClick={() => setOpened(false)}>
                  <img src="/assets/closeham.svg" alt="" />
                </div>
              </div>

              <div className="menu-links">
                <div className="menu-about"></div>
                <NavLink
                  to="/about"
                  onClick={() => {
                    setOpened(false);
                    setStatus("#121212");
                  }}
                >
                  About
                </NavLink>
                <NavLink to="/pricing" onClick={() => setOpened(false)}>
                  Pricing
                </NavLink>
                <NavLink to="/faqs" onClick={() => setOpened(false)}>
                  FAQs
                </NavLink>
                <a href="https://medium.com/@qevoltlimited" target="_blank">
                  Blog
                </a>
                <NavLink to="/contact" onClick={() => setOpened(false)}>
                  Contact
                </NavLink>
                <a href="https://app.qevolt.com/account" target="_blank">
                  Login
                </a>
                <div className="menu-signup" onClick={() => setOpened(false)}>
                  <a
                    href="https://app.qevolt.com/account/signup"
                    target="_blank"
                  >
                    Sign up
                  </a>
                </div>
              </div>
            </div>
          </Drawer>

          <Group position="center">
            {/* <Button onClick={() => setOpened(true)}>Open Drawer</Button> */}
            <div className="hamburger">
              <img src={ham} alt="" onClick={() => setOpened(true)} />
            </div>
          </Group>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
